export default "__VITE_ASSET__Djfy_PZ0__"